<template>
  <TListContainer>
    <TListItem class="my-1 px-2 text-xs/6 font-medium text-gray-500">
      {{ t('searchForm.location.suggestedDestinations') }}
    </TListItem>

    <TListItem>
      <SearchBarLocationSuggestion
       
        :title="nearbyText"
        :subtitle="t('searchForm.location.nearbySubtitle')"
        @click="emit('nearby')"
      />
    </TListItem>

    <TListItem
      v-for="(location, index) in suggestedLocations"
      :key="location.name"
    >
      <SearchBarLocationSuggestion
       
        :title="location.name"
        :subtitle="`${location.regionCode}, ${location.countryName}`"
        @click="emit('select', { text: location.name, placeId: location.placeId ?? '' })"
      />
    </TListItem>
  </TListContainer>
</template>

<script setup lang="ts">
import useSuggestedLocations from './useSuggestedLocations'
import type { SearchLocation } from '~/types'

defineProps<{
  nearbyText: string
}>()

const emit = defineEmits<{
  nearby: []
  select: [location: SearchLocation]
}>()

const { t } = useI18n()
const { suggestedLocations } = useSuggestedLocations(5)
</script>

<i18n src="~~/i18n/locales/common/search/form.json" lang="json" />
